import { __assign, __spreadArrays } from "tslib";
import Color from 'color';
import ColorHash from 'color-hash';
import find from 'lodash/find';
import get from 'lodash/get';
import memoize from 'lodash/memoize';
var colorHash = new ColorHash();
var shadeCustomColor = function (color, shade) {
    if (shade === 'main') {
        return color;
    }
    if (shade === 'light') {
        return lighten(color);
    }
    return darken(color);
};
export var getLegibleTextColor = memoize(function (bg, contrast) {
    if (contrast === void 0) { contrast = 4.5; }
    var bgColor = new Color(bg);
    var findWithContrast = function (darken) {
        if (darken >= 1) {
            return bgColor.darken(1).hex();
        }
        var textColor = bgColor.darken(darken);
        if (textColor.contrast(bgColor) >= contrast) {
            return textColor.hex();
        }
        return findWithContrast(darken + 0.05);
    };
    return findWithContrast(0.1);
});
export var generateColorFromString = memoize(function (text) {
    return colorHash.hex(text.replace(/\s/g, ''));
});
export var isLight = function (color) {
    return Color(color).luminosity() > 0.65;
};
export var opaque = function (color, opacity) {
    return new Color(__spreadArrays(Color(color).array(), [opacity])).string();
};
export var lighten = function (color) { return Color(color).fade(0.3).string(); };
export var darken = function (color, amount) {
    return Color(color)
        .darken(amount || 0.2)
        .string();
};
export var getColoringType = function (props) {
    var type = find(Object.keys(props), function (b) {
        return !!props[b] && !!find(Object.keys(props.theme.colors), function (k) { return k === b; });
    });
    return type;
};
export var getColor = function (props, key, shade) {
    if (get(props, key)) {
        return shadeCustomColor(get(props, key), shade);
    }
    var type = getColoringType(props);
    if (type) {
        var color = get(props.theme, "colors." + type);
        if (color != null && typeof color === 'object') {
            return color[shade];
        }
        else {
            return shadeCustomColor(color, shade);
        }
    }
};
export var getThemeColoring = function (theme, props, shade) {
    if (shade === void 0) { shade = 'main'; }
    var type = find(Object.keys(props), function (b) { return !!props[b] && !!theme.colors[b]; });
    if (type) {
        return getColor(__assign(__assign({}, props), { theme: theme }), type, shade);
    }
    return '';
};
